module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rpre"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Preface#pre"
    }
  }, [_c('i', [_vm._v("Preface and Acknowledgments")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rabb"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Abbreviation#abb"
    }
  }, [_c('i', [_vm._v("A Note on Transliteration and Abbreviation")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-3",
    attrs: {
      "id": "rintr"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Introduction#intr"
    }
  }, [_vm._v("Introduction: Ledi Sayadaw and the Gifts of the Buddha")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-1",
    attrs: {
      "id": "rch01"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Chapter_1#ch01"
    }
  }, [_vm._v("1 The Best of Times and the Worst: Ledi Sayadaw’s Formative Period")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-1",
    attrs: {
      "id": "rch02"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter_2#ch02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2 The Great War of the Commentaries: Ledi Sayadaw’s Abhidhamma Controversy")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-1",
    attrs: {
      "id": "rch03"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter_3#ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3 “In the Hands of All the People”: Ledi Empowers the Laity")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-1",
    attrs: {
      "id": "rch04"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter_4#ch04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4 “In This Very Life”: Lay Study of the Abhidhamma")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-1",
    attrs: {
      "id": "rch05"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter_5#ch05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5 The Birth of Insight")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-3",
    attrs: {
      "id": "rcon"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Conclusion#con",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusion: The Death of Ledi and the Life of Insight")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-2",
    attrs: {
      "id": "rglo"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Glossary#glo",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Glossary")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rnot"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Notes#not",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Notes")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rbib"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Bibliography#bib",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Bibliography")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rinde"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Index#inde",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Index")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2b41fffc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/Contents.vue
// module id = 69
// module chunks = 0